var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-767 -128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826 189.8C813.5 186.8 805.1 193.2 804.7 193.5 803.8 194.2 803.7 195.4 804.3 196.3 804.7 196.8 805.3 197.1 805.9 197.1 806.3 197.1 806.8 197 807.1 196.7 807.2 196.6 814.3 191.2 825 193.7 826.1 194 827.2 193.3 827.4 192.2 827.8 191.1 827.1 190 826 189.8Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805 172.7C805 176.014 802.314 178.7 799 178.7 795.686 178.7 793 176.014 793 172.7 793 169.386 795.686 166.7 799 166.7 802.314 166.7 805 169.386 805 172.7Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.2 161.7 804.2 160.7C805.3 160.6 806.1 159.6 806 158.5 805.9 157.4 804.9 156.6 803.8 156.7L793.8 157.7C792.7 157.8 791.9 158.8 792 159.9 792.1 160.9 793 161.7 794 161.7 794.1 161.7 794.1 161.7 794.2 161.7Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 172.7C837 176.014 834.314 178.7 831 178.7 827.686 178.7 825 176.014 825 172.7 825 169.386 827.686 166.7 831 166.7 834.314 166.7 837 169.386 837 172.7Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.2 157.7 826.2 156.7C825.1 156.6 824.1 157.4 824 158.5 823.9 159.6 824.7 160.6 825.8 160.7L835.8 161.7C835.9 161.7 835.9 161.7 836 161.7 837 161.7 837.9 160.9 838 159.9 838.1 158.8 837.3 157.8 836.2 157.7Z",
    fill: "#116D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 142C833.7 142 849 157.3 849 176 849 194.7 833.7 210 815 210 796.3 210 781 194.7 781 176 781 157.3 796.3 142 815 142M815 138C794 138 777 155 777 176 777 197 794 214 815 214 836 214 853 197 853 176 853 155 836 138 815 138L815 138Z",
    fill: "#116D6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.31375cc07a5e6a54c764454977fd4e87.svg";
export { ForwardRef as ReactComponent };